import weekIcon from 'src/public/img/illustration-behavior-dog.svg';
import congratulationsIcon from 'src/public/img/illustration-smiley-face.svg';

import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CBTProgramStepProps } from '../../models/cbtProgram';
import { BehavioralExposuresStep } from '../stepComponents/BehavioralExposuresStep';
import { ExposureExample1Step } from '../stepComponents/ExposureExample1Step';
import { ExposureExample2Step } from '../stepComponents/ExposureExample2Step';
import { ExposuresAndThoughtsStep } from '../stepComponents/ExposuresAndThoughtsStep';
import { ExposuresCheckInStep } from '../stepComponents/ExposuresCheckInStep';
import { ExposureExampleSummaryStep } from '../stepComponents/ExposuresExampleSummaryStep';
import { ExposuresFlexibilityStep } from '../stepComponents/ExposuresFlexibilityStep';
import { ExposuresPracticeStep } from '../stepComponents/ExposuresPracticeStep';
import { PickAnExposureStep } from '../stepComponents/PickAnExposureStep';
import { PickingExposuresStep } from '../stepComponents/PickingExposuresStep';
import { TakingTheNextStep } from '../stepComponents/TakingTheNextStep';
import { YourExposureHierarchyStep } from '../stepComponents/YourExposureHierarchyStep';
import { CBTProgramWeekSevenStep } from './weekSeven';

const steps: (ProgramSharedStep | CBTProgramWeekSevenStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CBTProgramWeekSevenStep.ExposuresCheckInStep,
    CBTProgramWeekSevenStep.TakingTheNextStep,
    CBTProgramWeekSevenStep.BehavioralExposuresStep,
    CBTProgramWeekSevenStep.ExposuresAndThoughtsStep,
    CBTProgramWeekSevenStep.PickingExposuresStep,
    CBTProgramWeekSevenStep.ExposureExample1Step,
    CBTProgramWeekSevenStep.ExposureExample2Step,
    CBTProgramWeekSevenStep.ExposureExampleSummaryStep,
    CBTProgramWeekSevenStep.YourExposureHierarchyStep,
    CBTProgramWeekSevenStep.PickAnExposureStep,
    CBTProgramWeekSevenStep.ExposuresFlexibilityStep,
    ProgramSharedStep.PlanStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CBTProgramStepProps[] = [
    {
        id: CBTProgramWeekSevenStep.ExposuresCheckInStep,
        component: ExposuresCheckInStep,
        tooltip: 'Alternative behavior',
        noButtons: true,
    },
    {
        id: CBTProgramWeekSevenStep.TakingTheNextStep,
        component: TakingTheNextStep,
        tooltip: 'Taking the next step',
        noButtons: true,
    },
    {
        id: CBTProgramWeekSevenStep.BehavioralExposuresStep,
        component: BehavioralExposuresStep,
        tooltip: 'Behavioral Exposures',
    },
    {
        id: CBTProgramWeekSevenStep.ExposuresAndThoughtsStep,
        component: ExposuresAndThoughtsStep,
        tooltip: 'Exposures & Thoughts',
    },
    {
        id: CBTProgramWeekSevenStep.PickingExposuresStep,
        component: PickingExposuresStep,
        tooltip: 'Picking Exposures',
    },
    {
        id: CBTProgramWeekSevenStep.ExposureExample1Step,
        component: ExposureExample1Step,
        tooltip: 'Exposure Example #1',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekSevenStep.ExposureExample2Step,
        component: ExposureExample2Step,
        tooltip: 'Exposure Example #2',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekSevenStep.ExposureExampleSummaryStep,
        component: ExposureExampleSummaryStep,
        tooltip: 'Exposure Example',
    },
    {
        id: CBTProgramWeekSevenStep.YourExposureHierarchyStep,
        component: YourExposureHierarchyStep,
        tooltip: 'Your exposure hierarchy',
        noButtons: true,
    },
    {
        id: CBTProgramWeekSevenStep.PickAnExposureStep,
        component: PickAnExposureStep,
        tooltip: 'Pick an exposure',
        noButtons: true,
    },
    {
        id: CBTProgramWeekSevenStep.ExposuresFlexibilityStep,
        component: ExposuresFlexibilityStep,
        tooltip: 'Exposure Flexibility',
    },
    {
        id: ProgramSharedStep.PlanStep,
        component: ExposuresPracticeStep,
        tooltip: 'Exposure Practice',
    },
];

const t = (key: string) => `cbt:week-7.data.${key}`;

export const weekSevenData = {
    id: ProgramWeekEnum.WeekSeven,
    weekNumber: 6,
    readableWeekNumber: 7,
    iconUrl: weekIcon,
    congratulationsIconUrl: congratulationsIcon,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};
